<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="
            mb-2
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>
          <div class="page-title-right">
            <div class="col-md text-right">
              <router-link :to="{ name: 'CreateDocumentType' }" class="btn btn-primary">
                <b>Nouveau</b>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pb-4">
        <div class="q-pa-md">
          <div v-if="isLoading" class="mt-2">
            <b-skeleton-table :rows="6" :columns="3"></b-skeleton-table>
          </div>
          
          <div class="row" v-else-if="documentTypes.length > 0">
            <div class="col-12 col-md-6 d-block d-lg-none"  v-for="documentType in pageOfItems" :key="documentType.id">
              <b-card class="border">
                <b-dropdown class="card-drop float-right" right variant="white" toggle-class="p-0">
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-vertical font-size-18"></i>
                  </template>

                  <b-dropdown-item @click="
                        $router.push({
                          path: `/document-types/edit/${documentType.id}`,
                        })
                      ">
                    {{ $t("pages.workflow.form.setup") }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="onDelete(documentType.id)">
                    {{ $t("pages.documentType.delete") }}
                  </b-dropdown-item>
                </b-dropdown>
                
                <b-card-title>
                  {{ documentType.name }}
                </b-card-title>

                <b-card-text>{{ documentType.description }}</b-card-text>

                <b-card-text class="small text-muted">{{ $d(new Date(documentType.created_at), 'short') }}</b-card-text>
              </b-card>
            </div>
            <div class="col-12 d-none d-lg-table">
              <table class="table table-hover mt-2">
                <thead class="thead-light">
                  <tr>
                    <th class="text-left">
                      {{ $t("pages.documentType.designation") }}
                    </th>
                    <th class="text-left">
                      {{ $t("pages.documentType.description") }}
                    </th>
                    <th class="text-left">Date</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="documentType in pageOfItems" :key="documentType.id">
                    <td>{{ documentType.name }}</td>
                    <td>{{ documentType.description }}</td>
                    <td>
                      {{ $d(new Date(documentType.created_at), 'short') }}
                    </td>
                    <td class="text-center">
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>

                        <!-- <b-dropdown-item @click="
                              $router.push({
                                path: `/document-types/show/${documentType.id}`,
                              })
                            ">
                          {{ $t("pages.documentType.display") }}
                        </b-dropdown-item> -->

                        <b-dropdown-item @click="
                              $router.push({
                                path: `/document-types/edit/${documentType.id}`,
                              })
                            ">
                          {{ $t("pages.workflow.form.setup") }}
                        </b-dropdown-item>

                        <b-dropdown-item @click="onDelete(documentType.id)">
                          {{ $t("pages.documentType.delete") }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="text-center empty-state-container" v-else>
            <div class="row">
              <div class="col-md-3 mx-auto">
                <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
              </div>
            </div>
            <h4 class="text-center">{{ $t("pages.documentType.inactiveDoc") }}</h4>
            <p class="mt-2"> {{ $t("pages.documentType.userData") }}</p>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination :pageSize="pageSize" :items="documentTypes" @changePage="onChangePage" :labels="labels"
                class="text-center"></jw-pagination>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions } from "vuex";
import LottieAnimation from "lottie-web-vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Document-types",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    LottieAnimation
  },
  data() {
    return {
      isLoading: false,
      title: "pages.documentType.typeDocument",
      items: [
        {
          text: "menuitems.dashboards.text",
        },
        {
          text: "pages.documentType.typeDocument",
        },
        {
          text: "pages.documentType.list",
          active: true,
        },
      ],

      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 5,
      // documentTypes: []
    };
  },
  methods: {
    ...mapActions(["getDocumentTypes", "deleteDocumentType"]),
    onDelete(id) {
      if (this.$can("delete", "document-types")) {
        this.$toasted.clear();
        this.$swal({
          text: `Etes-vous sûr de vouloir supprimer ce type de document  ?`,
          type: this.$t("pages.users.swal.type"),
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("pages.users.delete"),
        }).then((result) => {
          if (result.value) {
            this.deleteDocumentType(id)
              .then((response) => {
                if (response.status == 200) {
                  this.isDeleting = true;
                  this.$swal(
                    "Supprimé!",
                    "L'utilisateur supprimé avec succès.",
                    "success"
                  ).then(() => {
                     this.$store.dispatch("getDocumentTypes");
                  });
                } else {
                  this.isDeleting = false;
                }
              })
              .catch((error) => {
                if (error.response.status === 500) {
                  this.$toasted.error(
                    "Impossible de supprimer ce type de document",
                    {
                      duration: 4000,
                      position: "top-center",
                    }
                  );
                }
              });
          }
        });
      } else {
        this.isLoading = false;
        this.$toasted.error(
          "Une erreur est survenue, Veuillez réessayer SVP...",
          {
            duration: 3000,
            position: "top-center",
          }
        );
      }
    },
    show(userId) {
      this.$router.push({ path: `/users/show/${userId}` });
    },

    edit(userId) {
      this.$router.push({ path: `/document-types/edit/${userId}` });
    },

    load_image(picture) {
      // console.log(process.env.VUE_APP_PROFILE_URL + picture);
      return process.env.VUE_APP_IMAGE_URL + picture;
    },

    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
  },
  computed: {
    // ...mapState({
    //   documentTypes: (state) => state.documentType.documentTypes,
    // }),

    documentTypes: function () {
      return this.$store.state.documentType.documentTypes;
    },
  },

  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.$toasted.clear();
    }, 2000);

    this.$store.dispatch("getDocumentTypes")
      .then(() => {
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>



